import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@bd/bdui-modal';
import { withSize } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../../styles';
import MenuItems from './MenuItems';
import AreaMap from './AreaMap';

const modalStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  margin: 0;
  height: auto;
  background-color: ${colors.brand3};
  @media (min-width: 992px) {
    background-color: ${colors.white};
    top: 16%;
    left: 50%;
    transform: translateX(-50%);
    right: auto;
    width: 70%;
    max-width: 1100px;
    bottom: auto;
  }
  .MenuModal_close {
    position: absolute;
    right: 0;
    top: 0;
    width: 34px;
    height: 39px;
    background-color: ${colors.brand2};
    padding: 0;
    z-index: 2;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 22px;
    border: 0;
    @media(min-width: 992px) {
      top: 0;
    }
    &::after, &::before {
      position: absolute;
      right: 20px;
      top: 1px;
      content: ' ';
      height: 33px;
      width: 2px;
      background-color: ${colors.white};
    }
    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
    &:focus {
      outline: none;
    }
  }
  .MenuModal_btn {
    height: 60px;
    display: flex;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 17px;
    line-height: 1;
    color: ${colors.white};
    background-color: ${colors.brand2};
    text-transform: uppercase;
    cursor: pointer;
    margin: 45px 0 0 0;
    &:focus {
      outline: none;
    }
  }
  .MenuModal_contentWrapper {
    width: 90%;
    max-width: 400px;
    margin: 0 auto;
    padding: 30px;
    @media(min-width: 992px) {
      padding: 45px;
      width: 100%;
      max-width: none;
    }
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1002;
  background-color: rgba(0,0,0, 0.5);
  overflow-y: auto;
`;

class MenuModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      mapView: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate() {
    this.checkSize();
  }

  closeMapView = () => {
    this.setState({ mapView: false });
  }

  checkSize() {
    const { size } = this.props;

    if (size.width < 992 && this.state.mapView) {
      this.closeMapView();
    }
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
        openMenu: 'Louisiana',
      });
    }
  }

  closeModal = e => {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  mapViewToggler = () => {
    if (window.matchMedia('(min-width: 992px)').matches) {
      this.setState({ mapView: !this.state.mapView });
    } else {
      this.setState({ mapView: false });
    }
  }
  toggleOpenMenu = city => {
    this.setState({
      openMenu: city,
    });
  }
  render() {
    const { mapView, openMenu } = this.state;
    const { children, size } = this.props;
    return (
      <div className="MenuModal_wrapper">
        <span role="button" tabIndex={0} onClick={this.openModal} className="MenuModal_btn">
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Video Modal"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <button className="MenuModal_close" onClick={this.closeModal} />
          <div className="MenuModal_contentWrapper">
            {
              !mapView &&
              <MenuItems
                closeModal={this.closeModal}
                openMenu={openMenu}
                toggleOpenMenu={this.toggleOpenMenu}
                desktop={size.width > 991}
                submetroMenu={false}
                productMenu
              />
            }
            {
              mapView &&
              <AreaMap />
            }
            {/* <span className="MenuModal_btn" role="button" tabIndex={0}
            onClick={this.mapViewToggler}>
              <img src={mapView ? '/images/icon-list-white.svg' : '/images/icon-map-pin-white.svg'}
              alt="Icon Toggle Map" className="mr-3" height="20" width="auto" />
              {`View By ${mapView ? 'List' : 'Map'}`}
            </span> */}
          </div>
        </Modal>
      </div>
    );
  }
}

MenuModal.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.object.isRequired,
};


export default withSize()(MenuModal);



// WEBPACK FOOTER //
// ./src/components/Header/MenuModal/index.js